module.exports = __webpack_public_path__ + "static/lagnese-bg-87b0653e4536bd7accc26ee9e954abda.mp4";